import {
  Component,
  OnInit,
  HostListener,
  inject,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';
import { ModalService } from '../shared/services/modal.service';
import { BlockDocumentUiComponent } from '../shared/components/blockui/block-document-ui.component';
import { StorageService } from '../auth/services/storage.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    BlockDocumentUiComponent,
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css',
})
export class LayoutComponent implements OnInit {
  @ViewChild('modalContainer', { read: ViewContainerRef })
  modalContainer!: ViewContainerRef;
  sidebarVisible = false;
  sidebarCollapsed = false;
  isMobile = false;
  private initialLoad = true;
  private readonly sidebarCollapsedKey = 'bussify.layout.sidebarCollapsed';

  private readonly modalService = inject(ModalService);
  private readonly storage = inject(StorageService);

  ngAfterViewInit(): void {
    this.modalService.setViewContainerRef(this.modalContainer);
  }

  ngOnInit(): void {
    this.restoreSidebarState();
    this.checkScreenSize();
    // Prevent flash on initial load
    setTimeout(() => {
      this.initialLoad = false;
    }, 0);
  }

  @HostListener('window:resize')
  onResize(): void {
    this.checkScreenSize();
  }

  private checkScreenSize(): void {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth < 768;

    if (!this.isMobile) {
      this.sidebarVisible = true;
    } else if (this.initialLoad || !wasMobile) {
      // On initial load or when switching to mobile, close sidebar
      this.sidebarVisible = false;
    }
  }

  toggleSidebar(): void {
    this.sidebarVisible = !this.sidebarVisible;
  }

  onSidebarCollapsedChange(collapsed: boolean): void {
    this.sidebarCollapsed = collapsed;
    this.storage.setItem(this.sidebarCollapsedKey, String(collapsed));
  }

  private restoreSidebarState(): void {
    const storedValue = this.storage.getItem(this.sidebarCollapsedKey);
    this.sidebarCollapsed = storedValue === 'true';
  }
}
